import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { DcsPermissions, GridCellEnum, ICustomColumn, IPageProps } from 'types'
import { AddButton, PageHeader } from 'components'
import { V1ApiIntegrationsClient } from 'core/http-common'
import toast from 'core/toast'
import SAGrid, { GridGetDataProps, GetDataResponse } from 'components/Grid/SAGrid'
import { GridRowClickEvent } from '@progress/kendo-react-grid'
import { hasPermission } from 'state/reduxHelpers'
import { DEFAULT_PERMISSION_MESSAGE } from 'core/consts'
import { anyPermissionsRedirect } from 'core/helpers'

const SMSPage = ({ title }: IPageProps) => {

    const navigate = useNavigate()

    const smsColumns: ICustomColumn[] = [
        { field: 'dealerId', title: 'Dealer ID', width: '120px' },
        { field: 'dealerName', title: 'Dealer Name' },
        { field: 'phoneNumber', title: 'Phone Number', width: '170px' },
        { field: 'hostedSms', title: 'Hosted SMS', cellType: GridCellEnum.YesNoBoolean, width: '140px' },
        { field: 'deleted', title: 'Deleted', cellType: GridCellEnum.YesNoBoolean, width: '100px' },
        { field: 'pending', title: 'Pending', cellType: GridCellEnum.YesNoBoolean, width: '120px' },
        { field: 'twilioStatus', title: 'Twilio Status', width: '150px' },
        { field: 'createdDate', title: 'Created Date', format: '{0:g}', filterType: 'date', width: '175px' },
        { field: 'closedDate', title: 'Closed Date', format: '{0:g}', filterType: 'date', width: '175px' },
    ]

    const rowClicked = (e: GridRowClickEvent) => {
        if (!hasPermission(DcsPermissions.EditSmsNumber)) {
            toast.error(DEFAULT_PERMISSION_MESSAGE)
            return
        }

        navigate(`/integrations/sms/edit/${e.dataItem.accountSid}`)
    }

    const fetch = async (props: GridGetDataProps): Promise<GetDataResponse> => {
        try {
            const result = await V1ApiIntegrationsClient.getTwilioAccounts(
                props.search,
                props.sortBy,
                props.sortAscending,
                props.paging && props.paging.currentPage ? props.paging.currentPage : 1,
                props.paging ? props.paging.take : 50,
                true,
                true
            )

            return {
                data: result.data,
                total: result.totalItems ? result.totalItems : 0
            }
        }
        catch (e) {
            toast.responseErrors(e)
            return {
                data: [],
                total: 0
            }
        }
    }

    return (
        <div id='SMSPage'>
            <PageHeader title={title}>
                <AddButton
                    className='btn-lg btn-primary btnWidth mb-2 mb-md-0'
                    onClick={() => anyPermissionsRedirect([DcsPermissions.AddSmsNumber], '/integrations/sms/add', navigate)}>
                    Add SMS
                </AddButton>
            </PageHeader>

            <Row>
                <Col>
                    <SAGrid
                        features={{
                            pageable: true,
                            reorderColumns: true,
                            sortable: true,
                            simpleSearch: true
                        }}
                        columns={smsColumns}
                        defaultSort={[{ field: 'dealerId', dir: 'asc' }]}
                        getData={fetch}
                        onRowClick={rowClicked}
                    />
                </Col>
            </Row>
        </div>
    )
}
export default SMSPage
